import { Box } from '@mui/material';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import GroupsDataGrid from '../groups-data-grid/groups-data-grid.component';
import { useGroupsFilters } from '../groups-landing.hooks';
import BulkEditDataGridProvider from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';

const GroupsImported = () => {
  const search = useGroupsFilters();

  return (
    <Box mt={2}>
      <SearchProvider value={search}>
        <SearchToolbar />
        <BulkEditDataGridProvider>
          <GroupsDataGrid isImported />
        </BulkEditDataGridProvider>
      </SearchProvider>
    </Box>
  );
};

export default GroupsImported;
